'use client';

import {useI18n, useFormatNumber} from '@udemy-v2/i18n';
import classNames from 'classnames';
import styles from './enrollment-count.module.scss';

interface EnrollmentCountProps {
    /** The number of students enrolled in the course */
    count: number;
}

/**
 * Displays the number of students enrolled in a course
 * Uses i18n for number formatting and translation
 */
export const EnrollmentCount = ({count}: EnrollmentCountProps) => {
    const {gettext, interpolate} = useI18n();
    const {formatNumber} = useFormatNumber();

    return (
        <div className={classNames(styles['student-count'], 'ud-text-sm')}>
            <span>
                {interpolate(
                    gettext('%(formattedCount)s students'),
                    {formattedCount: formatNumber(count)},
                    true,
                )}
            </span>
        </div>
    );
};
